/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleMsIcon16Light } from './ShapeCircleMsIcon16Light';
import { ShapeCircleMsIcon16Regular } from './ShapeCircleMsIcon16Regular';
import { ShapeCircleMsIcon16Solid } from './ShapeCircleMsIcon16Solid';
import { ShapeCircleMsIcon20Light } from './ShapeCircleMsIcon20Light';
import { ShapeCircleMsIcon20Regular } from './ShapeCircleMsIcon20Regular';
import { ShapeCircleMsIcon20Solid } from './ShapeCircleMsIcon20Solid';
import { ShapeCircleMsIcon24Regular } from './ShapeCircleMsIcon24Regular';
import { ShapeCircleMsIcon24Solid } from './ShapeCircleMsIcon24Solid';
import { ShapeCircleMsIcon32Regular } from './ShapeCircleMsIcon32Regular';
import { ShapeCircleMsIcon64Regular } from './ShapeCircleMsIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleMsIcon16Light,
        regular: ShapeCircleMsIcon16Regular,
        solid: ShapeCircleMsIcon16Solid,
    },
    20: {
        light: ShapeCircleMsIcon20Light,
        regular: ShapeCircleMsIcon20Regular,
        solid: ShapeCircleMsIcon20Solid,
    },
    24: {
        regular: ShapeCircleMsIcon24Regular,
        solid: ShapeCircleMsIcon24Solid,
    },
    32: {
        regular: ShapeCircleMsIcon32Regular,
    },
    64: {
        regular: ShapeCircleMsIcon64Regular,
    },
};
export var ShapeCircleMsIcon = forwardRef('ShapeCircleMsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
